import { EmoticonAngryIcon } from './EmoticonAngryIcon';

/**
 * author: Michael Irigoyen
 * id 5DD5C53F-8D3F-43DE-81B9-667A5372A808
 * name emoticon-angry
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-angry.svg
 * tags
 * - Emoji 
 */
export const FaceAngryIcon = EmoticonAngryIcon;
export default FaceAngryIcon